import * as moment from 'moment';
import * as _ from 'underscore';

import { Component, Input, OnDestroy, OnInit } from '@angular/core';

import { UNSORTED_TABLE_KEY_NAMES } from '../../../analytics/constants/analytics.constants';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { DataTableComponent } from '../datatable/datatable.component';

@Component({
	selector: 'app-datatable-v3',
	styleUrls: ['./datatable-v3.component.css'],
	templateUrl: './datatable-v3.component.html'
})
export class DatatableV3Component extends DataTableComponent implements OnInit, OnDestroy {
	@Input() sectiontitle: string;
	@Input() key: string;
	@Input() datatableconfig;
	@Input() isTotalCalc;
	@Input() sortBy: boolean;
	@Input() defaultsort: string | boolean;
	@Input() downloadcsvcolumns: any;
	@Input() queryorderby: any;
	@Input() downloadcsvorderby: any;
	public asc = {};
	public downloadCSVColumns: any;
	public isR3: boolean = false;
	public isR4: boolean = false;
	protected progressBarData = {};

	constructor(protected analyticsService: AnalyticsService, protected analyticsDataModel: AnalyticsDataModel) {
		super(analyticsService, analyticsDataModel);
	}

	ngOnInit(): void {
		this.isR3 = ['default-r3', 'default-marketron-r3'].includes(
			this.analyticsDataModel.config.directoryName.toLowerCase()
		);
		this.isR4 = ['default-r4'].includes(this.analyticsDataModel.config.directoryName.toLowerCase());
		super.ngOnInit();
		if (typeof this.datatableconfig === 'string') {
			this.datatableconfig = JSON.parse(decodeURI(this.datatableconfig));
		}
		if (this.defaultsort === 'true') {
			this.defaultsort = JSON.parse(this.defaultsort);
		} else if (this.defaultsort !== true) {
			this.defaultsort = null;
		}
	}

	ngOnDestroy(): void {
		super.ngOnDestroy();
	}
	customSort(headerName: string): void {
		if (!this.asc[headerName]) {
			this.dataTableObj.data = _.sortBy(this.dataTableObj.data, (item) => {
				return moment(item[headerName]);
			});
			this.asc[headerName] = true;
		} else {
			this.dataTableObj.data = _.sortBy(this.dataTableObj.data, (item) => {
				return moment(item[headerName]);
			}).reverse();
			this.asc[headerName] = false;
		}
	}

	numberSort(headerName: string): void {
		// removing formatted_ from number columns
		const header = headerName.replace('formatted_', '');
		if (!this.asc[headerName]) {
			this.dataTableObj.data = _.sortBy(this.dataTableObj.data, (item) => {
				return item[header];
			});
			this.asc[headerName] = true;
		} else {
			this.dataTableObj.data = _.sortBy(this.dataTableObj.data, (item) => {
				return item[header];
			}).reverse();
			this.asc[headerName] = false;
		}
	}

	generateDateTableConfiguration(responseData: any): void {
		this.dataTableObj.data = this.generateResponseDataFromConfig(responseData);
		if (!this.defaultsort) {
			this.sortDataByImpressionsInDescendingOrder();
		}
		this.processDataForProgressBar(this.dataTableObj.data);
	}

	sortDataByImpressionsInDescendingOrder(): void {
		if (UNSORTED_TABLE_KEY_NAMES.indexOf(this.key) < 0) {
			if (this.dataTableObj.data[0] ? this.dataTableObj.data[0].impressions : false) {
				this.dataTableObj.data = _.sortBy(this.dataTableObj.data, 'impressions').reverse();
			} else {
				this.dataTableObj.data = _.sortBy(this.dataTableObj.data, 'Impressions').reverse();
			}
		}
		if ((this.isR3 || this.isR4) && this.sectiontitle === 'Browsers') {
			const othersBrowser = this.dataTableObj.data.filter((item) => item.browser_name.toUpperCase().includes('OTHER'));
			this.dataTableObj.data = this.dataTableObj.data.filter(
				(item) => !item.browser_name.toUpperCase().includes('OTHER')
			);
			this.dataTableObj.data.sort((a, b) => (a.clicks > b.clicks ? -1 : b.clicks > a.clicks ? 1 : 0));
			if (othersBrowser.length > 0) {
				this.dataTableObj.data.push(othersBrowser[0]);
			}
		}
		this.processDataForProgressBar(this.dataTableObj.data);
	}

	getPropMax(data: any[], prop: string): void {
		return data.reduce((max, p) => {
			p[prop] = parseFloat(p[prop].replace(/\,/g, ''));
			return p[prop] > max ? p[prop] : max;
		}, parseFloat(data[0][prop].replace(/\,/g, '')));
	}

	getPercentage(row: object, prop: string): object {
		if (this.progressBarData[prop] > 0) {
			const percentage = (row[prop].replace(/\,/g, '').replace(/\%/g, '') / this.progressBarData[prop]) * 100;
			return { width: `${Math.floor(percentage)}%` };
		} else {
			return { width: `0%` };
		}
	}

	processDataForProgressBar(data: any[]): void {
		if (data.length === 0) {
			return;
		}
		const dataObj = JSON.parse(JSON.stringify(data));
		const columns = this.dataTableObj.columns;
		for (const colObj of columns) {
			if (colObj.hasProgressBar) {
				this.progressBarData[colObj.prop] = this.getPropMax(dataObj, colObj.prop);
			}
		}
	}
}
